/* Contains an API path for each generic table on the dashboard */
export enum Table {
    SlaughterSettlements = 'slaughters/tables/slaughtersettlements',
    FeedConsumption = 'feed/tables/feedconsumption',
    PigsDeaths = 'pigs/tables/deadpigs',
    PigsMovements = 'pigs/tables/pigmovements',
    PigsSold = 'departures/tables/departures',
    DeliveryRegistrations = 'feed/tables/delivery-registrations',
    DeliveryOriginal = 'feed/tables/delivery-original',
}
